<template>
  <div class="row">
    <div class="col-12 col-lg-8">
      <div v-if="$store.getters['auth/isAllowed']('view_fullreport') &&
                ($store.getters['users/candidate/isTestPassed']('MMPI') || $store.getters['users/candidate/isTestPassed']('MINIMULT')
                || $store.getters['users/candidate/isTestPassed']('NUMERIC_LOGIC')
                || $store.getters['users/candidate/isTestPassed']('NON_VERBAL_LOGIC') || $store.getters['users/candidate/isTestPassed']('VERBAL_LOGIC')
              )"
        class="report-item"
      >
        <div class="font-weight-600">
          <a :href="isProfile ? '/reports/main' : `/candidates/${candidate.id}/reports/main`">Полный отчет</a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="$store.getters['auth/isAllowed']('download_fullreport')"
            :loading="loading.pdf.index"  @downloadPdf="loadPdfStd"/>
          <v-btn fab class="ml-4" small text :to="isProfile ? '/reports/main' : `/candidates/${candidate.id}/reports/main`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>

        </div>
      </div>
      <div v-if="$store.getters['auth/isAllowed']('view_shortreport') &&
                ($store.getters['users/candidate/isTestPassed']('MMPI') || $store.getters['users/candidate/isTestPassed']('MINIMULT'))"
            class="report-item"
      >
        <div class="font-weight-600">
          <a :href="isProfile ? '/reports/short' : `/candidates/${candidate.id}/reports/short`">Краткий отчет</a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="$store.getters['auth/isAllowed']('download_shortreport')"
              :loading="loading.pdf.short" class="load-pdf" @downloadPdf="loadPdfShort($event)"
          />
          <v-btn fab class="ml-4" small text :to="isProfile ? '/reports/short' : `/candidates/${candidate.id}/reports/short`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-if="psExists && $store.getters['auth/isAllowed']('view_psychotypereport')" class="report-item">
        <div class="font-weight-600">
          <a :href="isProfile ? '/reports/psycho' : `/candidates/${candidate.id}/reports/psycho`">Отчет респондента</a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="$store.getters['auth/isAllowed']('download_psychotypereport')"
              :loading="loading.pdf.psycho" class="load-pdf" @downloadPdf="loadPdfPsycho($event)"
          />
          <v-btn fab class="ml-4" small text :to="isProfile ? '/reports/psycho' : `/candidates/${candidate.id}/reports/psycho`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-if="$store.getters['auth/isAllowed']('view_recommendations') && $store.getters['users/candidate/isTestPassed']('MMPI')"
          class="report-item"
      >
        <div class="font-weight-600">
          <a :href="isProfile ? '/reports/reco' : `/candidates/${candidate.id}/reports/reco`">Отчет с рекомендациями</a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="$store.getters['auth/isAllowed']('download_recommendations')"
              :loading="loading.pdf.reco" class="load-pdf" @downloadPdf="loadPdfReco($event)"
          />
          <v-btn fab class="ml-4" small text :to="isProfile ? '/reports/reco' : `/candidates/${candidate.id}/reports/reco`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-if="$store.getters['auth/isAllowed']('view_riskfactor') && $store.getters['users/candidate/isTestPassed']('MMPI')"
        class="report-item"
      >
        <div class="font-weight-600">
          <a :href="isProfile ? '/reports/checklist' : `/candidates/${candidate.id}/reports/checklist`">Поведенческие риски</a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="$store.getters['auth/isAllowed']('download_riskfactor')"
              :loading="loading.pdf.checklist" class="load-pdf" @downloadPdf="loadPdfCheckList($event)"
          />
          <v-btn fab class="ml-4" small text :to="isProfile ? '/reports/checklist' : `/candidates/${candidate.id}/reports/checklist`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>
        </div>
      </div>

      <div v-for="t in constructorTests" :key="t" class="report-item">
        <div class="font-weight-600">
          <a :href="isProfile ? `/reports/constructor?test=${t}` : `/candidates/${candidate.id}/reports/constructor?test=${t}`">
            {{ results.constructor_test_results[t].name ? results.constructor_test_results[t].name : 'Профессиональный навигатор' }}
          </a>
        </div>
        <div class="d-flex">
          <PdfButton v-if="isReportDownloadAllowed(t)" showMenuReportWithRec
            :loading="loading.pdf.constructor && curTest===t"  @downloadPdf="loadPdfConstructor($event, t)"/>
          <v-btn fab class="ml-4" small text :to="isProfile ? `/reports/constructor?test=${t}` : `/candidates/${candidate.id}/reports/constructor?test=${t}`">
            <v-icon large>mdi-arrow-top-right</v-icon>
          </v-btn>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import PdfButton from '@/components/ui/PdfButton';
import { downloadFileHelper } from '@/common/util.js';

export default {
  name: 'ProfileData',
  components: {
    PdfButton
  },
  props: {
    user: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    curTest: ''
  }),
  inject: {
    isProfile: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      candidate: 'users/candidate/candidate',
      loading: 'users/candidate/loading',
      isReportAllowed: 'tests/isReportAllowed',
      isReportDownloadAllowed: 'tests/isReportDownloadAllowed',
      results: 'users/candidate/results',
      ps_current: 'users/candidate/resultsPsycho',
      ps_types: 'users/candidate/psychoTypes',
    }),
    isProfile() {
      return this.$route.name === 'profile';
    },
    psExists() {
      return this.ps_current?.main;
    },
    psMain() {
      return this.ps_current?.main ? this.ps_types.find((el) => el.code === this.ps_current.main[0]) : null;
    },
    constructorTests() {
      return this.results.constructor_test_results
        ? Object.keys(this.results.constructor_test_results).filter(test => this.isReportAllowed(test))
        : [];
      }

  },
  methods: {
    ...mapActions({
      loadCandidatePdf: 'users/candidate/loadCandidatePdf',
      loadCandidatePsychoPdf: 'users/candidate/loadCandidatePsychoPdf',
      loadCandidateRecomendationsPdf: 'users/candidate/loadCandidateRecomendationsPdf',
      loadCandidateCheckListPdf: 'users/candidate/loadCandidateCheckListPdf',
    }),
    ...mapMutations({
    }),
    // downloadFile(resp) {
    //   if (resp.error) {
    //     this.$toast.error(`Ошибка: ${resp.error}`, '', { position: 'topRight' });
    //     return;
    //   }
    //   const link = document.createElement('a');
    //   link.setAttribute('download', true);
    //   link.setAttribute('href', resp.link);
    //   link.setAttribute('target', '_blank');
    //   link.style.display = 'none';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },

    downloadFile(resp) {
      try {
        downloadFileHelper(resp);
      } catch (err) {
        this.$toast.error(err.message, '', { position: 'topRight' });
      }
    },
    async loadPdfStd({ logo }) {
      const resp = await this.loadCandidatePdf({ candidate: this.candidate.id, report_type: 'index', logo });
      this.downloadFile(resp);
    },
    async loadPdfShort({ logo }) {
      const resp = await this.loadCandidatePdf({ candidate: this.candidate.id, report_type: 'short', logo });
      this.downloadFile(resp);
    },
    async loadPdfConstructor({ logo, typeReco }, t) {
      this.curTest = t;
      const resp = await this.loadCandidatePdf({
        candidate: this.candidate.id,
        report_type: 'constructor',
        report_test: t,
        logo,
        candidate_recommendations: typeReco === 'candidate',
      });
      this.downloadFile(resp);
    },
    async loadPdfPsycho({ logo }) {
      const resp = await this.loadCandidatePsychoPdf({ candidate: this.candidate.id, ps_code: this.psMain.code, logo });
      this.downloadFile(resp);
    },
    async loadPdfReco({ logo }) {
      const data = {
        candidate: this.candidate.id,
        report_type: 'original', // editable
        logo,
        target: 1
      };
      const resp = await this.loadCandidateRecomendationsPdf(data);
      this.downloadFile(resp);
    },
    async loadPdfCheckList({ logo }) {
      const data = {
        candidate: this.candidate.id,
        report_type: 'original', // editable
        target: 1,
        logo
      };
      const resp = await this.loadCandidateCheckListPdf(data);
      this.downloadFile(resp);
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/styles/variables";

.report-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin: 4px 10px 10px 4px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05), 2px 0px 4px rgba(0, 0, 0, 0.05), -2px 0px 2px rgba(3, 3, 15, 0.05);
  border-radius: 4px;
}

</style>
